import React, { Component } from 'react';
import styles from '../Layout.module.css';
import { FormattedMessage } from 'react-intl';
import _ from 'classnames';

export default class Footer extends Component {
    render() {
        return (
            <React.Fragment>
                <div className={_(styles.noPrint, styles.container)}>
                    <div data-qaid="privacyText" className={styles.typography_privacy_policy}>
                        <a
                            href="https://webmdignite.com/krames-fhir-privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FormattedMessage
                                id="footer.PrivacyPolicy"
                                defaultMessage="PRIVACY POLICY"
                            />
                        </a>
                    </div>
                    <div data-qaid="copyrightText" className={styles.typography_footer}>
                        &copy;{' '}
                        <FormattedMessage
                            id="footer.Copyright"
                            defaultMessage="2019 The StayWell Company, LLC All Rights Reserved."
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
